import React, { useState } from "react";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import shippingMethodsService from "../../../services/shipping-methods.service";
import { useEffect } from "react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useErrorHandler } from "../../../hooks";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

export default function ShippingMethodsPage() {
  const [data, setData] = useState([]);
  const { initials } = useSelector((s) => s.app);
  const errorHandler = useErrorHandler();

  const deleteItem = (item) => {
    return shippingMethodsService.deleteShippingMethod(item.id);
  };

  const headerCells = useMemo(
    () => [
      {
        field: "name",
        title: "نام",
        mainField: true,
      },
      {
        field: "targetStatus",
        title: "وضعیت بعد پرداخت",
        // disableSort: true,
        renderer: (val) =>
          initials?.enums?.orderStatus?.find?.((t) => t.value === val)?.title,
      },
      {
        field: "isActive",
        title: "وضعیت",
        // disableSort: true,
        renderer: (val) => (val ? "فعال" : "غیر فعال"),
      },

      {
        field: "addressRequired",
        title: "نیاز به آدرس",
        // disableSort: true,
        renderer: (val) => (val ? "دارد" : "ندارد"),
      },
    ],
    [initials]
  );

  useEffect(() => {
    onRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRefresh = async () => {
    const { data, error } = await shippingMethodsService.getShippingMethods();
    if (error) {
      errorHandler(error);
      return;
    }
    setData(data);
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد روش ارسال",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        // actions={[
        //   {
        //     icon: <AddIcon />,
        //     tooltip: "ایجاد زیر خدمت",
        //     modalContent: (props) => (
        //       <FormModalContent {...props} serviceId={id} />
        //     ),
        //     modalProps: { maxWidth: "sm" },
        //   },
        // ]}
        searchKeys={defaultKeys}
        data={data}
        onRefresh={onRefresh}
        title="روش‌های ارسال"
      />
    </div>
  );
}
